import assembleURLHash from './route/assembleURLHash';

export default function hrefModuleList(params) {
    if (!params.blank && params.type === 'rightPanel') {
        this.dataSet('rightPanel', {}, 'RightPanel');

        return;
    }

    let queryStringParams = null;
    if (params.queryStringParams) {
        queryStringParams = {};
        for (const key of params.queryStringParams) {
            queryStringParams[key] = params[key];
        }
    }

    if (params.blank) {
        window.open(assembleURLHash('list', params.relModule, null, queryStringParams), '_blank');
    } else {
        this.href(assembleURLHash('list', params.relModule, null, queryStringParams));
    }
}
